<template>
  <div
    class="ai-avatar"
    :class="{ pulse: withPulse }"
  >
    <Icon name="lucide:sparkles" />
  </div>
</template>

<script setup>
defineProps({
  withPulse: { type: Boolean, required: false, default: false }
});
</script>

<style scoped>
.ai-avatar{align-items:center;background:linear-gradient(135deg,#6366f1,#8b5cf6);border-radius:50%;color:#fff;display:flex;flex-shrink:0;font-size:16px;height:40px;justify-content:center;width:40px}.ai-avatar.pulse{animation:pulse 2s infinite}@keyframes pulse{0%,to{opacity:1;transform:scale(1)}50%{opacity:.8;transform:scale(1.05)}}
</style>
